import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { GoogleSpreadsheet } from "google-spreadsheet";


const sheet0 = JSON.parse(process.env.REACT_APP_SHEET_ID)[0]
const sheet1 = JSON.parse(process.env.REACT_APP_SHEET_ID)[1]

const doc = new GoogleSpreadsheet(process.env.REACT_APP_SPREADSHEET_ID);
const appendSpreadsheet = async (row) => {
    try {
        await doc.useServiceAccountAuth({
            client_email: process.env.REACT_APP_CLIENT_EMAIL,
            private_key: process.env.REACT_APP_PRIVATE_KEY,
        });
        // loads document properties and worksheets
        await doc.loadInfo();

        const sheet = doc.sheetsById[sheet0];
        const result = await sheet.addRow(row);
    } catch (e) {
        console.error('Error: ', e);
    }
};

const appendSpreadsheet2 = async (row) => {
    try {
        await doc.useServiceAccountAuth({
            client_email: process.env.REACT_APP_CLIENT_EMAIL,
            private_key: process.env.REACT_APP_PRIVATE_KEY,
        });
        // loads document properties and worksheets
        await doc.loadInfo();

        const sheet = doc.sheetsById[sheet1];
        const result = await sheet.addRow(row);
    } catch (e) {
        console.error('Error: ', e);
    }
};


// const newRow = { Name: "new name", Value: "new value" };

// appendSpreadsheet(newRow);

const onSubmit = (event) => {
    event.preventDefault(event);
};



// Model
function MyVerticallyCenteredModal({ show, onHide, setInfo, info }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Hi Dear
  </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <p>
                    Write your name and email, we will contact you soon!
            </p>
                <Form>
                    <Form.Group className="card-form">
                        <Form.Control onChange={(e) => setInfo({ ...info, name: e.target.value })} type="text" placeholder="Name" />
                        <Form.Control onChange={(e) => setInfo({ ...info, email: e.target.value })} type="text" placeholder="Email" />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <a className="close-form" onClick={onHide}>Close</a>
                {/* <Button onClick={props.onHide}>Close</Button> */}
                <button className="submit-form" onClick={() => { appendSpreadsheet({ Name: info.name, Email: info.email, Plan: info.plan }); onHide() }} >Submit</button>
            </Modal.Footer>
        </Modal>
    );
}



const Index = function () {
    const { t, i18n } = useTranslation();
    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
    };
    const [modalShow, setModalShow] = React.useState(false);
    const [info, setInfo] = useState({ name: "", email: "", plan: "" });

    return (<>
        <div className="announcement">
            <small>{t('announcement')}</small>
        </div>

        <div className="custom-container">

            <header>
                <nav>

                    <ul>
                        <li className="left"><a href=""><img id="logo" src="img/logo.png" alt="logo" /></a></li>
                        <li className="link-item"><a href="#Start">{t('start')}</a></li>
                        <li className="link-item"><a href="#Activities">{t('activity-nav')}</a></li>
                        <li className="link-item"><a href="#Prices">{t('price')}</a></li>
                        <li className="link-item"><a href="#Companions">{t('companions')}</a></li>
                        <li id="lang">
                            <a
                                onClick={() => changeLanguage('en')}
                                style={{ cursor: "pointer" }}
                            >en</a> | <a
                                onClick={() => changeLanguage('sp')}
                                style={{ cursor: "pointer" }}
                            >sp</a></li>
                    </ul>
                </nav>

                <section>
                    <div id="slang">
                        <p className="slang"> <strong>{t('The company')}</strong> {t('slang')}</p>
                        <p className="slang-des">{t('slang-des')}</p>
                    </div>
                    <img id="elder-image" src="img/elder-image.png" alt="Companion caring elder lady" />
                </section>

            </header>

            <section className="daytime">
                <span id="Activities" className="title">{t('activities')}</span>
                <small>{t("activity-des")}</small><br />
                <small>{t("activity-des2")}</small>
            </section>

            <section className="activities">
                <img src="Icons/1.png" alt="games" />
                <img src="Icons/2.png" alt="event buddy" />
                <img src="Icons/3.png" alt="coffe/tea buddy" />
                <img src="Icons/4.png" alt="Arts & Crafts" />
                <img src="Icons/5.png" alt="Heath & Wellbeing" />
                <img src="Icons/6.png" alt="Outdoor adventures" />
                <img src="Icons/7.png" alt="Technology Help" />
            </section>

            <section className="schedule">
                <span className="title">{t('schedule')}</span>
                <small>{t('book-visit')}</small>
                <div>
                    <b>{t('date-time')}</b>
                </div>
            </section>

            <section id="Prices" className="price-plan">
                <span className="title">{t('price-plan')}</span>
                {/* <small>We currently offer <b>3 plans</b> to choose from and a trial <b>visit</b>.</small> */}
                <small>{t("price-des")}</small>
                <div style={{ marginTop: "80px" }}>
                    <small>
                        <b>{t("Launch")}</b>
                    </small>
                </div>
            </section>

            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                setInfo={setInfo}
                info={info}
            />

            <section className="price-cards">
                <div className="custom-card">
                    <h5>{t("trial")}</h5>
                    <hr />
                    <span className="price">25</span>
                    <p>{t("one-time")}</p>
                    <hr />
                    <div className="offer">
                        <p><b>1</b> {t("single-visit")}</p>
                        <p> <b>60</b> {t("minutes")}</p>
                        <br />
                    </div>
                    {/* <button onClick={() => appendSpreadsheet({ Name: "Hussein", Value: "OK", Age: "26" })}> {t("get")} {t("trial")}</button> */}
                    <Button variant="primary" onClick={() => { setModalShow(true); appendSpreadsheet2({ TRIAL: "1" }); setInfo({ ...info, plan: "Trial" }) }}>
                        {t("get")} {t("trial")}
                    </Button>


                    <p>{t("pre-sale")}</p>
                </div>

                <div className="custom-card">
                    <h5>{t("bronze")}</h5>
                    <hr />
                    <span className="price month">90</span>
                    <p>{t("bill-monthly")}</p>
                    <hr />
                    <div className="offer">
                        <p className="week-visit"><b>1 {t("visit")}</b></p>
                        <p><b>4</b> {t("total-visits")}</p>
                        <p style={{ marginBottom: "0px" }}> <b>60</b> {t("minutes-per")}</p>
                    </div>
                    <Button variant="primary" onClick={() => { setModalShow(true); appendSpreadsheet2({ BRONZE: "1" }); setInfo({ ...info, plan: "Bronze" }) }}>
                        {t("get")} {t("bronze")}
                    </Button>


                    <p>{t("no-cridit")}</p>
                </div>

                <div className="custom-card best-price">
                    <h5>{t("silver")}</h5>
                    <hr />
                    <span className="price month">159</span>
                    <p>{t("bill-monthly")}</p>
                    <hr />
                    <div className="offer">
                        <p className="week-visit"><b>2 {t("visits-week")} </b> </p>
                        <p><b>8</b> {t("visits")}</p>
                        <p> <b>60</b> {t("minutes-per")}</p>
                    </div>
                    <Button variant="primary" onClick={() => { setModalShow(true); appendSpreadsheet2({ SILVER: "1" }); setInfo({ ...info, plan: "Silver" }) }}>
                        {t("get")} {t("silver")}
                    </Button>

                    <p>{t("no-cridit")}</p>
                </div>

                <div className="custom-card">
                    <h5>{t("gold")}</h5>
                    <hr />
                    <span className="price month">405</span>
                    <p>{t("bill-monthly")}</p>
                    <hr />
                    <div className="offer">
                        <p className="week-visit"><b>3 {t("visit-week")} </b> </p>
                        <p><b>12</b> {t("visits")}</p>
                        <p> <b>120</b>{t("minutes-per")}</p>
                    </div>
                    <Button variant="primary" onClick={() => { setModalShow(true); appendSpreadsheet2({ GOLD: "1" }); setInfo({ ...info, plan: "Gold" }) }}>
                        {t("get")} {t("gold")}
                    </Button>
                    <p>{t("no-cridit")}</p>
                </div>


            </section>

            <section className="price-info">
                <small>{t("price-activity")}</small> <br />
                <small>{t("contact-email")}
                    <a href="mailto:info@companio.care">
                        <address> info@companio.care</address>
                    </a>
                </small>
            </section>

            <section id="Companions" className="companions">
                <span><b>{t("our-companions")}</b> </span><br /><br />
                {/* <small>Our colleagues are <b>normal</b> people . They are your neighbors, mothers and fathers, students and
                professionals looking for a change.</small> */}
                {/* <small> Before becoming a partner, each of the people are subjected to a rigorous <b>selection process</b> q
                ue includes:</small> */}
                <small>{t("companions-des")}</small><br />
                <small>{t("filter-companions")}</small>
            </section>

            <section id="vetting-process">
                <img src="Icons/face-to-face.png" alt="Face to face" />
                <img src="Icons/personality.png" alt="personality" />
                <img src="Icons/Police.png" alt="Police" />
                <img src="Icons/Reference.png" alt="Reference" />

            </section>

        </div>

        <section className="testimonial">
            <p className="qoute">❝</p>
            <i>
                <p>
                    {t("qoute0.1")}
                </p> <br />
                <p>
                    {t("qoute0.2")}
                </p> <br /><br />
            </i>

            <p><b>Camila, 54</b></p><br />
            <p>Client</p>
        </section>


        <div className="custom-container">


            <img id="footer-logo" src="img/logo.png" alt="logo" />
            <footer>

                <div>
                    <h3>{t("about-us")}</h3>
                    <p>{t("about-des")}</p>
                    <p>{t("rights")}</p>
                </div>

                <div>
                    <h3>{t("location")}</h3>
                    <p>{t("barcelona")}</p>
                    <p>info@companio.care</p>
                </div>

                <div>
                    <h3>{t("get-in-touch")}</h3>
                    <p>{t("get-in-touch-des")}
                    </p>

                </div>

            </footer>
        </div>


    </>)
}

export default Index;